import { useState } from "react";
import * as XLSX from "xlsx";

export default function UploadBoq() {

  const [boqData, setBoqData] = useState({});
  const [activeTab, setActiveTab] = useState("");
  const [search, setSearch] = useState("");

  const handleFile = (e) => {

    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {

      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const parsed = {};

      workbook.SheetNames.forEach((sheetName) => {

        const sheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(sheet);

        parsed[sheetName] = json;
      });

      setBoqData(parsed);
      setActiveTab(workbook.SheetNames[0]);
    };

    reader.readAsArrayBuffer(file);
  };

  const rows = boqData[activeTab] || [];

  const filteredRows = rows.filter((row) =>
    Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <div className="p-6">

      <h2 className="text-xl font-bold mb-4">Upload BOQ Excel</h2>

      <input
        type="file"
        accept=".xlsx,.xls"
        onChange={handleFile}
        className="mb-6"
      />

      {Object.keys(boqData).length > 0 && (
        <>
          {/* Tabs */}
          <div className="flex border-b mb-4 overflow-x-auto">

            {Object.keys(boqData).map((sheet) => (
              <button
                key={sheet}
                onClick={() => {
                  setActiveTab(sheet);
                  setSearch("");
                }}
                className={`px-4 py-2 mr-2 rounded-t ${
                  activeTab === sheet
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200"
                }`}
              >
                {sheet} ({boqData[sheet].length})
              </button>
            ))}

          </div>

          {/* Search */}
          <div className="mb-3">

            <input
              type="text"
              placeholder="Search items..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border px-3 py-2 rounded w-64"
            />

          </div>

          {/* Table */}
          <div className="border rounded max-h-[500px] overflow-auto">

            <table className="min-w-full text-sm">

              <thead className="bg-gray-100 sticky top-0">

                <tr>
                  {rows.length > 0 &&
                    Object.keys(rows[0]).map((col) => (
                      <th
                        key={col}
                        className="px-4 py-2 border font-semibold"
                      >
                        {col}
                      </th>
                    ))}
                </tr>

              </thead>

              <tbody>

                {filteredRows.map((row, i) => (
                  <tr key={i} className="hover:bg-gray-50">

                    {Object.values(row).map((val, j) => (
                      <td key={j} className="px-4 py-2 border">
                        {val}
                      </td>
                    ))}

                  </tr>
                ))}

                {filteredRows.length === 0 && (
                  <tr>
                    <td
                      colSpan={10}
                      className="text-center py-4 text-gray-500"
                    >
                      No results found
                    </td>
                  </tr>
                )}

              </tbody>

            </table>

          </div>

        </>
      )}

    </div>
  );
}